import React, { useEffect, useState, useRef } from "react";
import "./createToolboxtalk.scss";
import { FormControl, Grid, Box } from "@mui/material";
import { InputField } from "../../../../library/custom/textBox/InputField";
import SelectMenu from "../../../../library/custom/selectMenu/SelectMenu";
import FormLabels from "../../../../library/custom/formLabel/FormLabels";
import TextArea from "../../../../library/custom/textArea/TextArea";
import Button from "../../../../library/custom/button/Button";
import { formValidation } from "../../../../utils/incpectionHelper";
import { USER_ID } from "../../../../constant/constant";
import { useNavigate } from "react-router-dom";
import FormDropZone from "../../../../library/dropZone/FormDropZone";
import { InactiveClient } from "../../../../utils/helper";
import TextEditor from "../../../../library/custom/textEditor/TextEditor";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Tooltip from "@mui/material/Tooltip";

const CreateToolbox = ({
  categoryListData,
  editToolBoxData,
  onSubmit,
  toolboxId,
  editMode,
}) => {
  const [addPhoto, setAddPhoto] = useState("");
  const [images, setImages] = useState([]);

  const [errors, setErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const editor = useRef(null);
  useEffect(() => {
    if (editToolBoxData) {
      let coverImagePath;
      if (editToolBoxData?.file) {
        coverImagePath = editToolBoxData?.file?.path;

        setAddPhoto(coverImagePath);
      }
      setFormValue({
        descriptionSafetyMeeting:
          editToolBoxData?.descriptionSafetyMeeting ?? "",
        textSafetyMeeting: editToolBoxData?.textSafetyMeeting ?? "",
        titleSafetyMeeting: editToolBoxData?.titleSafetyMeeting ?? "",
        categoryId: editToolBoxData?.categoryId,
        fileIds: editToolBoxData?.file?.id ? [editToolBoxData?.file?.id] : [],
        toolboxTalkId: toolboxId,
        videoLink: editToolBoxData?.videoLink ?? "",
      });
    }
  }, [editToolBoxData]);
  const history = useNavigate();

  const [formValue, setFormValue] = useState({
    categoryId: "",
    titleSafetyMeeting: "",
    descriptionSafetyMeeting: "",
    textSafetyMeeting: "",
    imageUrl: "",
    fileIds: [],
    toolboxTalkId: "",
    videoLink: "",
  });

  const [isTitleSafetyMeeting, setIsTitleSafetyMeeting] = useState(false);
  const [videoLinkError, setVideoLinkError] = useState(false);

  const VIDEOLinkREGX =
    /^(https:\/\/(?:www\.)?(?:vimeo\.com\/(?:video\/|embed\/)?[0-9]+(\?.*)?|player\.vimeo\.com\/video\/[0-9]+(\?.*)?|youtube\.com\/embed\/[A-Za-z0-9_-]{11}(\?.*)?))$/;

  const normalizeToEmbedUrl = (url) => {
    if (!url || typeof url !== "string") return url;
    const trimmed = url.trim();
    return trimmed;
  };

  const validateVideoLink = (value) => {
    if (!value || !value.trim()) return true;
    const normalized = normalizeToEmbedUrl(value);
    return VIDEOLinkREGX.test(normalized);
  };

  const formHandler = (event, action) => {
    if (InactiveClient()) return;
    const videoLinkValid = validateVideoLink(formValue.videoLink);
    setVideoLinkError(!videoLinkValid);
    const normalizedVideoLink = formValue.videoLink?.trim()
      ? normalizeToEmbedUrl(formValue.videoLink)
      : null;

    const formData = {
      categoryId: formValue?.categoryId ?? null,
      titleSafetyMeeting: formValue?.titleSafetyMeeting ?? null,
      descriptionSafetyMeeting: formValue?.descriptionSafetyMeeting ?? null,
      textSafetyMeeting: formValue?.textSafetyMeeting ?? null,
      fileIds: formValue?.fileIds ?? [],
      createdBy: USER_ID(),
      toolboxTalkId: editMode ? toolboxId : "",
      videoLink: normalizedVideoLink ?? null,
    };

    const { errorKey } = formValidation(
      {
        titleSafetyMeeting: formValue.titleSafetyMeeting,
        categoryId: formValue.categoryId,
      },
      action,
    );
    setErrors(errorKey);
    let isError = false;
    if (
      !formValue.titleSafetyMeeting ||
      formValue.titleSafetyMeeting.trim() === ""
    ) {
      isError = true;
      setIsTitleSafetyMeeting(true);
      setFormValue({
        ...formValue,
        titleSafetyMeeting: "",
      });
    }
    if (!formValue.categoryId) {
      isError = true;
    }
    if (!videoLinkValid) {
      isError = true;
    }

    if (!isError) {
      setIsSubmit(true);

      onSubmit(formData);
    } else {
      setIsSubmit(false);
    }
  };

  const handleTitleChange = (event, value) => {
    let fName = event.target.value;
    setFormValue({
      ...formValue,
      titleSafetyMeeting: fName,
    });
  };

  const handleDescChange = (event, value) => {
    let Desc = event.target.value;
    setFormValue({
      ...formValue,

      descriptionSafetyMeeting: Desc,
    });
  };
  const handleTextChange = (event, value) => {
    setFormValue({
      ...formValue,

      textSafetyMeeting: event,
    });
  };

  const handleVideoLinkChange = (event, value) => {
    const val = (event?.target?.value ?? event ?? "") || "";
    setFormValue({ ...formValue, videoLink: val });
    if (videoLinkError && val.trim())
      setVideoLinkError(!validateVideoLink(val));
    else if (!val.trim()) setVideoLinkError(false);
  };

  useEffect(() => {
    setFormValue({
      ...formValue,
      fileIds: images,
    });
  }, [images]);

  const handleDeleteImageURL = (urls) => {
    setImages([]);
    setAddPhoto("");
  };

  return (
    <>
      <div className="overideToolbox">
        <div className="formContainer">
          {editToolBoxData ? (
            <div className="heading_style">
              <h1>Update Safety Meeting</h1>
            </div>
          ) : (
            <div className="heading_style">
              <h1>Create Safety Meeting</h1>
            </div>
          )}

          <div className="addtoolBoxContainer">
            <div className="addtoolBox">
              <Grid>
                <Grid
                  item
                  container
                  mt={1.5}
                  lg={12}
                  xs={12}
                  sm={12}
                  md={4}
                  spacing={1}
                >
                  <Grid item lg={6} xs={12}>
                    <FormControl fullWidth>
                      <FormLabels label="Category" isRequired={true} />
                      <SelectMenu
                        listData={categoryListData}
                        value={formValue.categoryId}
                        isRequired={true}
                        placeholder="Select Category"
                        onchangehandler={(e) =>
                          setFormValue({
                            ...formValue,
                            categoryId: e.target.value,
                          })
                        }
                        isError={!!errors?.categoryId ?? false}
                        errorMsg={errors?.categoryId ?? ""}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item container mt={1.5} lg={12} spacing={2}></Grid>

              <Grid mt={1.5} spacing={2} lg={12}>
                <FormControl fullWidth>
                  <InputField
                    isRequired={true}
                    fullWidth={true}
                    disabled={false}
                    placeholder="Enter title text here..."
                    type="text"
                    label="Title"
                    value={formValue.titleSafetyMeeting}
                    onChange={(event, value) => handleTitleChange(event, value)}
                    isError={
                      (!!errors?.titleSafetyMeeting || isTitleSafetyMeeting) ??
                      false
                    }
                    errorMsg={
                      isTitleSafetyMeeting
                        ? "Please enter this required field."
                        : ""
                    }
                  />
                </FormControl>
              </Grid>

              <Grid mt={3} spacing={2} lg={12}>
                <FormLabels label={"Description"} />

                <TextArea
                  name={"issuefound"}
                  placeholder="Add Safety Meeting description text here..."
                  value={formValue.descriptionSafetyMeeting}
                  onChange={(event, value) => handleDescChange(event, value)}
                />
              </Grid>

              <Grid mt={3} spacing={2} lg={12}>
                <FormLabels label={"Add Text"} />
                <TextEditor
                  value={formValue?.textSafetyMeeting}
                  onChange={(event) => handleTextChange(event)}
                  maxCharacters={20000}
                />
              </Grid>

              <Grid mt={3} spacing={2} lg={12}>
                <FormControl fullWidth>
                  <Box display="flex" alignItems="center" gap="1px">
                    <FormLabels label="Embed Video Link" isRequired={false} />
                    <Tooltip
                      title={
                        <div className="tooltip-main">
                          <div style={{ marginBottom: "6px", fontWeight: 600 }}>
                            When adding the Embed Video Link, only include the
                            link that is between the “two quotation marks”.
                          </div>

                          <div className="iframeSectionmain-heading">
                            {" "}
                            Example:
                          </div>
                          <div className="iframeSectionmain-heading">
                            YouTube:
                          </div>

                          <div className="iframeSectionmain">
                            &lt;iframe &nbsp;&nbsp;width="1122"
                            &nbsp;&nbsp;height="505" &nbsp;src="
                            <span className="green-link">
                              https://www.youtube.com/embed/4BzjUq921Y4
                            </span>
                            "<br />
                            &nbsp;&nbsp;title="The Power and Beauty of
                            Construction Sites: A Cinematic Reel"
                            &nbsp;&nbsp;frameborder="0"
                            &nbsp;&nbsp;allow="accelerometer; autoplay;
                            clipboard-write; encrypted-media; gyroscope;
                            picture-in-picture; web-share"
                            &nbsp;&nbsp;referrerpolicy="strict-origin-when-cross-origin"
                            &nbsp;&nbsp;allowfullscreen&gt; &lt;/iframe&gt;
                          </div>

                          <div className="iframeSectionmain-heading">
                            Vimeo:
                          </div>

                          <div className="iframeSectionmain">
                            &lt;iframe &nbsp;&nbsp;width="1122"
                            &nbsp;&nbsp;height="505" &nbsp;src="
                            <span className="green-link">
                              https://player.vimeo.com/video/11690541?badge=0&autopause=0&player_id=0&app_id=8479
                            </span>
                            " &nbsp;&nbsp;frameborder="0"
                            &nbsp;&nbsp;allow="autoplay; fullscreen;
                            picture-in-picture; clipboard-write;
                            encrypted-media; web-share"
                            &nbsp;&nbsp;referrerpolicy="strict-origin-when-cross-origin"
                            &nbsp;&nbsp;title="Title"&gt; &lt;/iframe&gt;
                          </div>
                        </div>
                      }
                      placement="bottom-start"
                      arrow
                      componentsProps={{
                        tooltip: {
                          sx: {
                            backgroundColor: "#ffffff",
                            color: "#333333",
                            fontFamily: "Lato",
                            fontSize: "13px",
                            padding: "8px 12px",
                            borderRadius: "8px",
                            border: "2px solid #ccc",
                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                            "body.dark-mode &": {
                              backgroundColor: "#333333",
                              color: "#ffffff",
                              border: "2px solid #79747e",
                            },
                          },
                        },
                        arrow: {
                          sx: {
                            color: "#ffffff",
                            "&::before": {
                              borderRadius: "2px",
                              border: "2px solid #ccc",
                            },
                            "body.dark-mode &": {
                              color: "#333333",
                              "&::before": {
                                border: "2px solid #79747e",
                              },
                            },
                          },
                        },
                      }}
                      //PopperProps={{ disablePortal: true }}
                    >
                      <InfoOutlinedIcon
                        fontSize="small"
                        className="infoOut-linedIcon"
                      />
                    </Tooltip>
                  </Box>
                  <InputField
                    fullWidth={true}
                    type="text"
                    id="videoLink"
                    placeholder="Embed Video Link"
                    value={formValue.videoLink ?? ""}
                    isError={videoLinkError}
                    onChange={handleVideoLinkChange}
                  />
                  {videoLinkError && (
                    <div className="error">Please add proper link.</div>
                  )}
                </FormControl>
              </Grid>

              <Grid mt={3} spacing={2} lg={12}>
                <FormDropZone
                  label={"Add Document/Image"}
                  paraText1={"Drop the file here ..."}
                  paraText2={"Drop document/image here, "}
                  paraText3={"or Browse"}
                  handleFileChange={(files, uploadfile) => {
                    setAddPhoto(files);
                    setImages(uploadfile);
                  }}
                  isDynamics={true}
                  fileType={10}
                  imageUrl={addPhoto}
                  deleteImageURL={(url) => handleDeleteImageURL(url)}
                  id="addPhoto"
                  key="addPhoto"
                  isMuliple={false}
                  isDoc={true}
                  isImage={false}
                />
              </Grid>

              <Grid item lg={4} xs={12} sm={12} md={4}></Grid>

              <Grid item lg={6} xs={12} sm={12} md={4}>
                <div className="adduser_btn">
                  <div
                    className="cancle_heading_style"
                    onClick={() => history(-1)}
                  >
                    Cancel
                  </div>

                  <Button
                    varientContained={true}
                    disabled={isSubmit ? true : false}
                    label={editToolBoxData ? "Update" : "publish"}
                    onClick={(e) =>
                      formHandler(e, editToolBoxData ? "update" : "submit")
                    }
                  />
                </div>
              </Grid>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default CreateToolbox;
